export const contracterConstants = {
    CONTRACTER_REQUEST: 'CONTRACTER_LOAD_REQUEST',
    CONTRACTER_SUCCESS: 'CONTRACTER_LOAD_SUCCESS',
    CONTRACTER_FAILURE: 'CONTRACTER_LOAD_FAILURE',

    CONTRACTER_CLOSE: 'CONTRACTER_CLOSE',
    CONTRACTER_TOGGLE_TYPE: 'CONTRACTER_TOGGLE_TYPE',
    CONTRACTER_GUIDE_TYPE: 'CONTRACTER_GUIDE_TYPE',

    GET_DOCNUM_REQUEST : 'GET_DOCNUM_REQUEST',
    GET_DOCNUM_SUCCESS : 'GET_DOCNUM_SUCCESS',
    GET_DOCNUM_FAILURE : 'GET_DOCNUM_FAILURE',

    RESET_CALLED: 'RESET_CALLED',
    SHOW_POPUP_ITEMS: 'SHOW_POPUP_ITEMS',
    SELECT_POPUP_ITEMS: 'SELECT_POPUP_ITEMS',

    GET_CONFIRMATION_REQUEST : 'GET_CONFIRMATION_REQUEST',
    GET_CONFIRMATION_SUCCESS : 'GET_CONFIRMATION_SUCCESS',
    GET_CONFIRMATION_FAILURE : 'GET_CONFIRMATION_FAILURE',

    STEP_SAVE: 'CONTRACTER_STEP_SAVE',
    SET_STEP_DATA: 'CONTRACTER_SET_STEP_DATA',
    TEMP_SAVE_REQUEST: 'CONTRACTER_TEMP_SAVE_REQUEST',
    TEMP_SAVE_SUCCESS: 'CONTRACTER_TEMP_SAVE_SUCCESS',
    TEMP_SAVE_FAILURE: 'CONTRACTER_TEMP_SAVE_FAILURE',
    TEMP_SAVE_SUCCESS_LIST: 'CONTRACTER_TEMP_SAVE_SUCCESS_LIST',

    TEMP_DELETE_REQUEST: 'TEMP_DELETE_REQUEST',
    TEMP_DELETE_SUCCESS: 'TEMP_DELETE_SUCCESS',
    TEMP_DELETE_FAILURE: 'TEMP_DELETE_FAILURE',

    SAVE_REQUEST: 'CONTRACTER_SAVE_REQUEST',
    SAVE_SUCCESS: 'CONTRACTER_SAVE_SUCCESS',
    SAVE_FAILURE: 'CONTRACTER_SAVE_FAILURE',

    ISSUE_REQUEST: 'CONTRACTER_ISSUE_REQUEST',
    ISSUE_SUCCESS: 'CONTRACTER_ISSUE_SUCCESS',
    ISSUE_FAILURE: 'CONTRACTER_ISSUE_FAILURE',

    SEND_REQUEST: 'CONTRACTER_SEND_REQUEST',
    SEND_SUCCESS: 'CONTRACTER_SEND_SUCCESS',
    SEND_FAILURE: 'CONTRACTER_SEND_FAILURE',
}
